// WithEditMessage.jsx
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import EditIconSource from '../../img/ic-edit-outline.svg';

export const WithEditMessage = ({
  messageId = null,
  meId = null,
  senderId = null,
  isEditMessageEnabled = false,
  isEditPermissionMatched = false,
  openMessageEditor = () => null,
  children = () => null,
}) => {
  const isAuthor = meId && meId === senderId;
  const handleOnClick = useCallback(() => {
    openMessageEditor({ messageId });
  }, [messageId, openMessageEditor]);
  const canEditMessage =
    isEditMessageEnabled && (isEditPermissionMatched || isAuthor);
  if (!messageId || !canEditMessage) return null;
  return children({
    handleOnClick,
    iconSource: EditIconSource,
  });
};

WithEditMessage.propTypes = {
  messageId: PropTypes.string,
  meId: PropTypes.string,
  senderId: PropTypes.string,
  isEditMessageEnabled: PropTypes.bool,
  isEditPermissionMatched: PropTypes.bool,
  children: PropTypes.func,
  openMessageEditor: PropTypes.func,
};

export default WithEditMessage;
